import { useCallback } from 'react';
import type { UpsellSurface } from 'fym-shared/src/music24/watermarkUpsell';
import { useMusic24Plan } from '../hooks/useMusic24Plan';
import { useWatermarkSummary } from './useWatermarkSummary';
import type { UpsellEventFacts } from './watermarkUpsellAnalytics';

/** Builds the properties of an upsell event for a surface: the surface, the file count, the plan. */
export function useUpsellEventFacts(): (surface: UpsellSurface) => UpsellEventFacts {
  const plan = useMusic24Plan();
  const { summary } = useWatermarkSummary();
  const { files } = summary;
  return useCallback((surface: UpsellSurface) => ({ surface, files, plan }), [files, plan]);
}
